import axios from 'axios/index';

export const SET_KUESIONER = '[INSTRUMEN] SET KUESIONER';
export const SIMPAN_KUESIONER = '[INSTRUMEN] SIMPAN KUESIONER';
export const GET_KUESIONER = '[INSTRUMEN] GET KUESIONER';
export const GET_PLAIN_KUESIONER = '[INSTRUMEN] GET PLAIN KUESIONER';
export const SET_KUESIONER_DIRTY = '[INSTRUMEN] SET KUESIONER DIRTY';
export const SET_RADIO_KUESIONER = '[INSTRUMEN] SET RADIO KUESIONER';
export const GET_REKAP_KEMAJUAN = '[INSTRUMEN] GET REKAP KEMAJUAN';
export const HITUNG_REKAP_KEMAJUAN = '[INSTRUMEN] HITUNG REKAP KEMAJUAN';
export const GET_RINCIAN_REKAP_KEMAJUAN = '[INSTRUMEN] GER RINCIAN REKAP KEMAJUAN';
export const SET_KONFIRMASI_SELESAI = '[INSTRUMEN] SET KONFIRMASI SELESAI';
export const GET_KONFIRMASI_SELESAI = '[INSTRUMEN] GET KONFIRMASI SELESAI';
export const SET_KUNCI_KONFIRMASI_INSTRUMEN = '[INSTRUMEN] SET KUNCI KONFIRMASI INSTRUMEN';
export const GET_PERINGKAT_PENGISIAN = '[INSTRUMEN] GET PERINGKAT PENGISIAN';
export const GET_KEMAJUAN_TOTAL = '[INSTRUMEN] GET KEMAJUAN TOTAL';
export const CATAT_TIMELINE = '[INSTRUMEN] CATAT TIMELINE';
export const CATAT_TIMELINE_BATAL = '[INSTRUMEN] CATAT TIMELINE BATAL';
export const INSTRUMEN_TOTAL = '[INSTRUMEN] INSTRUMEN TOTAL';
export const SIMPAN_JAWABAN_UTAMA = '[INSTRUMEN] SIMPAN JAWABAN UTAMA';
export const SIMPAN_JAWABAN_UTAMA_MANDIRI = '[INSTRUMEN] SIMPAN JAWABAN UTAMA MANDIRI';
export const PECAH_JAWABAN_UTAMA = '[INSTRUMEN] PECAH JAWABAN UTAMA';
export const PECAH_JAWABAN_UTAMA_SEMUA = '[INSTRUMEN] PECAH JAWABAN UTAMA SEMUA';
export const SIMPAN_JAWABAN_UTAMA_SEMUA = '[INSTRUMEN] SIMPAN JAWABAN UTAMA SEMUA';
export const CEK_JAWABAN_UTAMA_SEMUA = '[INSTRUMEN] CEK JAWABAN UTAMA SEMUA';
export const PROSES_FILE_IMPORT = '[INSTRUMEN] PROSES_FILE_IMPORT';
export const CEK_FILE_IMPORT = '[INSTRUMEN] CEK_FILE_IMPORT';
export const LOG_IMPORT_OS = '[INSTRUMEN] LOG_IMPORT_OS';

export function logImportOs(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/logImportOs', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : LOG_IMPORT_OS,
                payload: response.data,
                routeParams
            })
        });
}

export function ProsesFileImport(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/ProsesFileImport', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_FILE_IMPORT,
                payload: response.data,
                routeParams
            })
        });
}

export function CekFileImport(routeParams)
{
    
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/CekFileImport', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : CEK_FILE_IMPORT,
                payload: response.data,
                routeParams
            })
        });
}

export function getPeringkatPengisian(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/PeringkatPengisian', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_PERINGKAT_PENGISIAN,
                payload: response.data,
                routeParams
            })
        });
}


export function getKuesioner(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/KuesionerRoot', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_KUESIONER,
                payload: response.data,
                routeParams
            })
        });
}

export function getPlainKuesioner(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/plainKuesioner', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_PLAIN_KUESIONER,
                payload: response.data,
                routeParams
            })
        });
}

export function getRekapKemajuan(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/RekapKemajuan', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_REKAP_KEMAJUAN,
                payload: response.data,
                routeParams
            })
        });
}

export function getKemajuanTotal(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/KemajuanTotal', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_KEMAJUAN_TOTAL,
                payload: response.data,
                routeParams
            })
        });
}

export function getRincianRekapKemajuan(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/RincianRekapKemajuan', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_RINCIAN_REKAP_KEMAJUAN,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungRekapKemajuan(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');
    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.get(baseUrl + '/api/HitungRekapKemajuan', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : HITUNG_REKAP_KEMAJUAN,
                payload: response.data,
                routeParams
            })
        });
}

export function simpanKuesioner(routeParams)
{
    // console.log(routeParams);
    const baseUrl = localStorage.getItem('api_domain');

    // let bodyFormData = new FormData();
    // var headers = {
    //     'Content-Type': 'application/json', 
    // }

    // bodyFormData.append('params', routeParams);
    // bodyFormData.append('token', localStorage.getItem('jwt_token'));

    // localStorage.getItem('api_domain') + '/SPM/RaporSPM/RekapPersentaseSpmPerKecamatan?bentuk_pendidikan_id=' + value + '&start=' + this.state.offset + '&limit=20'
    const request = axios.post(baseUrl + '/api/instrumen', {
        token: localStorage.getItem('jwt_token'),
        data: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : SIMPAN_KUESIONER,
                hasil_simpan: response.data,
                routeParams
            })
        });
}

export function getKonfirmasiSelesai(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/KonfirmasiInstrumen', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : GET_KONFIRMASI_SELESAI,
                payload: response.data,
                routeParams
            })
        });
}

export function setKonfirmasiSelesai(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/KonfirmasiInstrumen', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : SET_KONFIRMASI_SELESAI,
                hasil_konfirmasi: response.data,
                routeParams
            })
        });
}

export function setKuesioner(kuesioner){
    return (dispatch) => {
        return dispatch ({
            type: SET_KUESIONER,
            kuesioner: kuesioner
        })
    }
}

export function setKunciKonfirmasiInstrumen(konfirmasi_instrumen_id){
    // console.log(konfirmasi_instrumen_id);

    return (dispatch) => {
        return dispatch ({
            type: SET_KUNCI_KONFIRMASI_INSTRUMEN,
            konfirmasi_instrumen_id: konfirmasi_instrumen_id
        })
    }
}

export function setKuesionerDirty(dirty){
    return (dispatch) => {
        return dispatch ({
            type: SET_KUESIONER_DIRTY,
            dirty: dirty
        })
    }
}

export function setRadioKuesioner(radioCheck){
    return (dispatch) => {
        return dispatch ({
            type: SET_RADIO_KUESIONER,
            radioCheck: radioCheck
        })
    }
}

export function catatTimeline(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/catatTimeline', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : CATAT_TIMELINE,
                payload: response.data,
                routeParams
            })
        });
}

export function catatTimelineBatal(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/catatTimelineBatal', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : CATAT_TIMELINE_BATAL,
                payload: response.data,
                routeParams
            })
        });
}


export function InstrumenAll(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/InstrumenAll', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            // console.log(response.data);
            return dispatch({
                type   : INSTRUMEN_TOTAL,
                payload: response.data,
                routeParams
            })
        });
}

export function simpanJawabanUtama(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/simpanJawabanUtama', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SIMPAN_JAWABAN_UTAMA,
                payload: response.data,
                routeParams
            })
        });
}

export function pecahJawabanUtama(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/pecahJawabanUtama', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PECAH_JAWABAN_UTAMA,
                payload: response.data,
                routeParams
            })
        });
}


export function pecahJawabanUtamaSemua(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/pecahJawabanUtamaSemua', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PECAH_JAWABAN_UTAMA_SEMUA,
                payload: response.data,
                routeParams
            })
        });
}


export function simpanJawabanUtamaSemua(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/simpanJawabanUtamaSemua', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SIMPAN_JAWABAN_UTAMA_SEMUA,
                payload: response.data,
                routeParams
            })
        });
}


export function cekJawabanUtamaSemua(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/cekJawabanUtamaSemua', {
        token: localStorage.getItem('jwt_token'),
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : CEK_JAWABAN_UTAMA_SEMUA,
                payload: response.data,
                routeParams
            })
        });
}


export function simpanJawabanUtamaMandiri(pengguna_id)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/simpanJawabanUtama', {
        token: localStorage.getItem('jwt_token'),
        pengguna_id: pengguna_id,
        mandiri: 1
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SIMPAN_JAWABAN_UTAMA_MANDIRI,
                payload: response.data  
            })
        });
}



// WEBPACK FOOTER //
// ./src/store/actions/Instrumen.actions.js